import { PDFDocument, rgb, degrees, StandardFonts } from 'pdf-lib';

export const addPreviewWatermarkToPdf = async (pdfBlob) => {
    const arrayBuffer = await pdfBlob.arrayBuffer();
    const pdfDoc = await PDFDocument.load(arrayBuffer);

    const font = await pdfDoc.embedFont(StandardFonts.HelveticaBold);
    const pages = pdfDoc.getPages();

    pages.forEach(page => {
        const size = page.getSize();
        const width = size.width;
        const height = size.height;

        for (let i = 0; i < height; i += 200) {
            page.drawText('TESTNO ŠTAMPANJE', {
                x: width / 4,
                y: i,
                size: 40,
                font,
                color: rgb(0.4, 0.4, 0.4),
                rotate: degrees(45),
                opacity: 0.1
            });
        }
    });

    const pdfBytes = await pdfDoc.save();
    return new Blob([pdfBytes], { type: 'application/pdf' });
};



// WEBPACK FOOTER //
// ./src/views/StudentService/StudentOverview/pdfUtils.js